module.exports = __webpack_public_path__ + "static/img/screen-logo.daa6fa45.png";